import { useTranslation } from 'react-i18next';
import styles from '../../Components/Bookings/Bookings.module.css';
import noimage from "../../Images/noimage.jpeg";
import { useDispatch } from 'react-redux';
import { DeleteCartItem } from '../../redux/Slices/Cart/thunk';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

// required for accessibility
Modal.setAppElement('#root');

export default function CartItem({ Carts }) {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedCart, setSelectedCart] = useState(null);
  const [actionType, setActionType] = useState(""); // 'delete' or 'edit'

  const openModal = (cart, type) => {
    setSelectedCart(cart);
    setActionType(type);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedCart(null);
    setActionType("");
    setModalIsOpen(false);
  };

  const handleAction = async () => {
    if (!selectedCart) return;

    if (actionType === "delete") {
      const id = selectedCart?.cart_srl?.trim();
      if (id) {
        await dispatch(DeleteCartItem(id));
      }
    } else if (actionType === "edit") {
      sessionStorage.setItem('cartFromCart', JSON.stringify(selectedCart));
      sessionStorage.setItem('isEditServisePreducer', true);
      navigate('/serviceproviders');
    }

    closeModal();
  };

  return (
    <>
      {Carts && Carts.map((cart) => (
        cart.client_id && (
          <div key={cart.cart_srl} className={`mx-auto ${styles.box} w-75 my-3`} style={{ position: "relative" }}>
            <div className={styles.CartName}>
              {cart.itm_nam || ''}
            </div>

            <div className={`d-flex justify-content-between flex-wrap-reverse m-2 ${styles.CardsLabelFonts}`}>
              <div>
                <div className='my-2'>
                  <span style={{ fontWeight: "700" }}>{t('service_provider')} : </span>
                  <span>{currentLanguage === "ar" ? cart?.emp_nam?.trim() : cart?.emp_enm?.trim() || 'غير متاح'} </span>
                </div>
                <div className='my-2'>
                  <span style={{ fontWeight: "700" }}>{t('branch')} : </span>
                  <span>{currentLanguage === "ar" ? cart?.brn_nam?.trim() : cart?.brn_enm?.trim() || 'غير متاح'} </span>
                </div>
                <div className='my-2'>
                  <span style={{ fontWeight: "700" }}>{t('date')} : </span>
                  <span>{cart?.date?.trim() || 'غير متاح'} </span>
                </div>
                <div className='my-2'>
                  <span style={{ fontWeight: "700" }}>{t('time')} : </span>
                  <span>{cart?.time?.trim() || 'غير متاح'} </span>
                </div>
                <div className='my-2'>
                  <span style={{ fontWeight: "700" }}>{t('price')} : </span>
                  <span>{Number(cart?.itm_price?.trim()).toFixed(2) || 'غير متاح'} {t('rs')}</span>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                <img
                  className={styles.ImageContainerSize}
                  style={{ borderRadius: "8px", border: "2px solid rgb(180, 147, 69)" }}
                  src={(cart?.image && cart?.image?.trim() !== "") ? cart?.image?.trim() : noimage}
                  alt="Service"
                />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", margin: "10px", gap: "10px" }}>
              <div
                onClick={() => openModal(cart, "delete")}
                className={styles.DeleteBtn}
              >
                {t('delete')}
              </div>
              <div
                onClick={() => openModal(cart, "edit")}
                className={styles.DeleteBtn}
              >
                {t('Edit')}
              </div>
            </div>
          </div>
        )
      ))}

      {/* React Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Confirm Action"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '12px',
            padding: '24px',
            width: '90%',
            maxWidth: '400px',
            textAlign: 'center'
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }
        }}
      >
        <h4 className="mb-3">
          {actionType === "delete" ? t("confirm_delete_title") : t("confirm_edit_title")}
        </h4>
        <p className="mb-4">
          {actionType === "delete" ? t("confirm_delete_message") : t("confirm_edit_message")}
        </p>
        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
          <button className="btn btn-secondary w-50" onClick={closeModal}>{t("cancel")}</button>
          <button className="btn w-50" style={{background:"#B49345", color:"white"}} onClick={handleAction}>{t("confirm")}</button>
        </div>
      </Modal>
    </>
  );
}
